import { useState, useEffect, useCallback } from 'react';
import { useApiReports } from '../api/api.reports';

/**
 * Hook personalizado para manejar la lógica de tableros de control
 * Puede ser usado en múltiples componentes (control-boards, Header, etc.)
 */
export const useControlBoards = () => {
  const [boards, setBoards] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedBoard, setSelectedBoard] = useState<any>(null);
  const { getControlsBoards } = useApiReports();

  // Cargar tableros al montar el hook
  useEffect(() => {
    loadBoards();
  }, []);

  const loadBoards = useCallback(() => {
    setLoading(true);
    getControlsBoards([])
      .then((res) => {
        setBoards(res);
      })
      .catch((err) => {
        console.error('Error loading boards:', err);
        setBoards([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [getControlsBoards]);

  const selectBoard = useCallback((board: any) => {
    if (!board) {
      setSelectedBoard(null);
      return;
    }

    try {
      // Clonar para evitar referencias mutables
      const cloned = JSON.parse(JSON.stringify(board));
      setSelectedBoard(cloned);
    } catch (err) {
      console.error('Error cloning board:', err);
      setSelectedBoard({ ...board });
    }
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedBoard(null);
  }, []);

  return {
    boards,
    loading,
    selectedBoard,
    selectBoard,
    clearSelection,
    reloadBoards: loadBoards,
  };
};
